// extracted by mini-css-extract-plugin
export default {"inputSelectWrapper":"language-select-module--inputSelectWrapper--3I1Md","wrapper":"language-select-module--wrapper--1JL-l"};